/**
 * DetailSynopsisContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail synopsis container.
 */
const DetailSynopsisContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  height: ${120 * Screen.widthRatio}px;
  width: ${982 * Screen.widthRatio}px;
  overflow: hidden;
`;

export default DetailSynopsisContainer;
